import type React from 'react';

import Text from '../../../../text';

type EmptyStateProps = {
  children: React.ReactNode;
};

const EmptyState = ({ children }: EmptyStateProps) => (
  <div className="text-left mt-2 mr-4 mb-2 ml-0">
    <Text variant="body-2" color="tertiary">
      {children}
    </Text>
  </div>
);

export default EmptyState;
